module.exports = require('./dist/lib/dynamic')
